import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { DialogCloseButton } from '../atoms/dialog_close_button';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { ZIndex } from '../constants';
export const DIALOG_WIDTH = 327;
export const DIALOG_WIDTH_XL = 519;
export const DIALOG_IMAGE_HEIGHT = 184;
export const DIALOG_IMAGE_HEIGHT_XL = 292;
const DEFAULT_BORDER_RADIUS = 8;
export const Dialog = ({ classObject, onClickCancel, content, closeButtonLabel, disableBackgroundCancel, isCloseButton, isBottom, borderRadius, strictSameSize, }) => {
    const onClickBackground = () => {
        if (disableBackgroundCancel)
            return;
        onClickCancel();
    };
    const onClickDialog = (e) => {
        e.stopPropagation();
    };
    if (!borderRadius) {
        borderRadius = DEFAULT_BORDER_RADIUS;
    }
    const additionalStyles = StyleSheet.create({
        borderRadius: {
            borderRadius: isBottom ? `${borderRadius}px ${borderRadius}px 0 0` : borderRadius,
        },
    });
    return (React.createElement("div", { className: css(styles.background), onClick: onClickBackground },
        React.createElement("div", { className: css(styles.dialogContent, strictSameSize && styles.dialogContentSameSize, isBottom ? styles.bottom : styles.top, additionalStyles.borderRadius, classObject), "data-test": "dialog", onClick: onClickDialog },
            content,
            isCloseButton && React.createElement(DialogCloseButton, { label: closeButtonLabel, onClick: onClickCancel }))));
};
const styles = StyleSheet.create({
    dialogContent: {
        position: 'absolute',
        left: '50%',
        transform: 'translate(-50%, -50%);',
        width: DIALOG_WIDTH,
        backgroundColor: Colors.GrayLight,
        [MediaBreakPointUp.XL]: {
            width: DIALOG_WIDTH_XL,
        },
    },
    dialogContentSameSize: {
        [MediaBreakPointUp.XL]: {
            width: DIALOG_WIDTH,
        },
    },
    top: {
        top: '50%', // FIXME: 下に張り付くダイアログのデザインが多いのでtopから計算しないように上位コンポーネントのCSSをbottomで計算するようにしてここは消す
    },
    bottom: {
        transform: 'translate(-50%, 0)',
        bottom: 0,
        width: '100%',
    },
    background: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: ZIndex.Dialog,
        background: Colors.BackgroundDialog,
    },
});
